export class SheetHelper {
    static desktopBreakpoint = 768;

    private static updateBodyScroll(): void {
        const anyOpen = document.querySelector(".db-sheet.show");
        if (anyOpen) {
            //document.body.classList.add("no-scroll");
        } else {
            //document.body.classList.remove("no-scroll");
        }
    }

    static closeAllSheets() {
        requestAnimationFrame(() => {
            const overlay = document.querySelector<HTMLElement>('.db-overlay');
            
            document.querySelectorAll<HTMLElement>(".db-sheet.show").forEach(sheet => {
                sheet.classList.remove("show");

                const desktopBreakpoint = this.desktopBreakpoint ?? 1024;
                if (window.innerWidth < desktopBreakpoint) {
                    sheet.style.bottom = "-100%";
                }

                if (overlay) {
                    overlay.classList.remove('show');
                }
            });

            this.updateBodyScroll();
        });
    }

    static closeOtherSheets(currentSheet: HTMLElement) {
        requestAnimationFrame(() => {
            const overlay = document.querySelector<HTMLElement>('.db-overlay');

            document.querySelectorAll<HTMLElement>(".db-sheet.show").forEach(sheet => {
                if (sheet !== currentSheet) {
                    sheet.classList.remove("show");

                    if (window.innerWidth < this.desktopBreakpoint) {
                        sheet.style.bottom = "-100%";
                    }

                    if (overlay && sheet.classList.contains('overlay')) {
                        overlay.classList.remove('show');
                    }
                }
            });

            this.updateBodyScroll();
        });
    }

    static toggleSheet(sheet: HTMLElement) {
        requestAnimationFrame(() => {
            const isOpen = sheet.classList.toggle("show");

            if (window.innerWidth < this.desktopBreakpoint) {
                // Mobile slide
                sheet.style.bottom = isOpen ? "0" : "-100%";
            } else {
                // Desktop dropdown
                // opacity and pointer-events handled via CSS
            }

            const overlay = document.querySelector<HTMLElement>('.db-overlay');
            if (overlay && sheet.classList.contains('overlay')) {
                overlay.classList.toggle('show', isOpen);
            }

            this.updateBodyScroll();
        });
    }

    static closeSheet(sheet: HTMLElement) {
        requestAnimationFrame(() => {
            sheet.classList.remove("show");

            if (window.innerWidth < this.desktopBreakpoint) {
                sheet.style.bottom = "-100%";
            }

            const overlay = document.querySelector<HTMLElement>('.db-overlay');
            if (overlay && sheet.classList.contains('overlay')) {
                overlay.classList.remove('show');
            }

            this.updateBodyScroll();
        });
    }

    static initCloseButtons(): void {
        document.addEventListener("click", (e) => {
            const target = e.target as HTMLElement;
            const closeBtn = target.closest(".btn-close-sheet");
            if (closeBtn) {
                const sheet = closeBtn.closest<HTMLElement>(".db-sheet");
                if (sheet) {
                    SheetHelper.closeSheet(sheet);
                }
            }
        });
    }
}
